import type { Hcp } from '@/core/graphql/generated/types';

/**
 * Type predicate to check if an object is of type Hcp.
 * Note: this is a loose type check
 */
export const isOfTypeHcp = (hcp: unknown): hcp is Hcp => {
	if (typeof hcp === 'object' && hcp !== null) {
		return '__typename' in hcp && hcp.__typename === 'HCP' && 'vid_V' in hcp;
	}

	return false;
};
